import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

export const defaultInternationalPackageName = <FormattedMessage {...messages.defaultInternationalPackageName} />;
export const defaultPackageName = <FormattedMessage {...messages.defaultPackageName} />;
export const defaultInternationalServiceName = <FormattedMessage {...messages.defaultInternationalServiceName} />;
export const defaultServiceName = <FormattedMessage {...messages.defaultServiceName} />;
export const defaultInternationalConfirmation = <FormattedMessage {...messages.defaultInternationalConfirmation} />;
export const defaultConfirmation = <FormattedMessage {...messages.defaultConfirmation} />;
export const editModalHeader = <FormattedMessage {...messages.editModalHeader} />;
export const addModalHeader = <FormattedMessage {...messages.addModalHeader} />;
export const editPresetGroupButton = <FormattedMessage {...messages.editPresetGroupButton} />;
export const addPresetGroupButton = <FormattedMessage {...messages.addPresetGroupButton} />;
export const save = <FormattedMessage {...messages.save} />;
export const cancel = <FormattedMessage {...messages.cancel} />;
